/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Paper, Space, Sx, Text, ThemeIcon, Title, Tooltip } from '@mantine/core';
import { useLingui } from '@lingui/react';
import { IconQuestionMark } from '@tabler/icons';
import { FC, ReactNode, useContext } from 'react';
import { WindowContext } from '../Service/Context/WindowContext';

const PanePaper: FC<{
  title?: string;
  children: ReactNode;
  rightSection?: ReactNode;
  tooltip?: string;
  withShadow?: boolean;
  withoutBorder?: boolean;
  borderlessVersion?: boolean;
  showTitle?: boolean;
  sx?: Sx;
}> = ({
  title,
  children,
  rightSection,
  tooltip,
  withShadow = false,
  withoutBorder = false,
  borderlessVersion = false,
  showTitle = false,
  sx,
}) => {
  const { i18n } = useLingui();
  const { xs, md } = useContext(WindowContext);

  return (
    <Paper
      radius={10}
      p={borderlessVersion ? 0 : 'md'}
      sx={(theme) => ({
        backgroundColor: borderlessVersion ? 'transparent' : theme.colorScheme === 'dark' ? 'inherit' : 'white',
        boxShadow: borderlessVersion
          ? 'none'
          : withShadow
          ? theme.colorScheme === 'dark'
            ? '0px 0px 8px rgba(255, 255, 255, 0.10)'
            : '0px 0px 8px #00000026'
          : 'none',
        border: borderlessVersion
          ? 'none'
          : withoutBorder
          ? 'none'
          : `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[1]}`,
        ...sx,
      })}
    >
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: 5,
        }}
      >
        {(!borderlessVersion || (showTitle && !xs)) && title && (
          <Text size="lg" weight="bolder">
            {i18n._(title)}
          </Text>
        )}
        {borderlessVersion && xs && title && <Title order={3}>{i18n._(title)}</Title>}
        {tooltip && !md && !borderlessVersion && (
          <Tooltip multiline withArrow position="bottom" label={i18n._(tooltip)} width={200} transition="slide-down">
            <ThemeIcon
              size={14}
              sx={(theme) => ({
                borderRadius: '50%',
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.silver[4] : theme.colors.gray[3],
              })}
            >
              <IconQuestionMark size={12} />
            </ThemeIcon>
          </Tooltip>
        )}
        {rightSection && <Box sx={{ position: 'absolute', right: 0, top: 0 }}>{rightSection}</Box>}
      </div>
      {title && <Space h="md" />}
      {children}
    </Paper>
  );
};

export default PanePaper;
